import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { fetchHouses, fetchRooms } from '../fetchData';

export const useLoadTreeData = ({
  treeData,
  setTreeData,
  initValues = {},
  cityId,
}) => {
  const queryClient = useQueryClient();

  const onLoadData = useCallback(
    (node) => {
      return new Promise(async (resolve, reject) => {
        const { children, key } = node;
        if (children) {
          resolve();
          return;
        }

        const keyParts = key.split('-');
        const fetch = keyParts.length === 1 ? fetchHouses : fetchRooms;

        const data = await fetch({
          queryClient,
          entityId: Number(keyParts.slice().pop()),
          node,
          cityId,
          init:
            keyParts.length === 1 ? initValues.houseIds : initValues.addressIds,
        });

        if (data) {
          node.children = data;
          setTreeData([...treeData, ...data]);
        }

        resolve();
      });
    },
    [
      queryClient,
      setTreeData,
      treeData,
      initValues.houseIds,
      initValues.addressIds,
      cityId,
    ]
  );

  return onLoadData;
};
